/*
 * @Description:外调车运单列表
 * @Author: WangYuhan
 * @Date: 2022-12-09 17:54:05
 * @LastEditTime: 2024-06-11 16:22:10
 * @LastEditors: lijinpeng
 */
// 引入api请求方法
import {
  forms,
  pay,
  payType,
  etc,
  oil,
  trajectory,
  extent,
  exception,
} from '@/utils/dictionary/waybillselect';
import {
  getGroups,
  getRouteListByBid,
  getProjectListByBid,
  getChannelInfoList,
  findChannelInfoByCorp,
} from '@/api/common';
import { waybillWdList, countByStatus, exportExcelTemplate } from '@/api/waybill';
import { filterTestCorp } from '@/utils/util';
import { postGroupUserList } from '@/api/enterprise';

const storeModuleName = 'waybillwdModule';
const state = {
  // 筛选项-
  parameters: [
    {
      style: 'select',
      param: 'businessId',
      isFixed: true,
      value: '',
      valueType: 'string',
      state: 'companyList',
      label: '企业',
      placeholder: '请选择',
      noMatchText: '无匹配企业',
      clearable: false,
      filterable: false,
      path: `${storeModuleName}/getCompanyList`,
    },
    {
      style: 'autocomplete',
      param: 'projectName',
      value: '',
      valueType: 'string',
      label: '项目名称',
      placeholder: '请输入',
      noMatchText: '无匹配请输入',
      clearable: true,
      filterable: false,
      path: `${storeModuleName}/getProjectList`,
    },
    {
      style: 'autocomplete',
      param: 'routeInfoName',
      value: '',
      valueType: 'string',
      label: '线路名称',
      placeholder: '请输入',
      noMatchText: '无匹配请输入',
      clearable: true,
      filterable: false,
      path: `${storeModuleName}/getRouteList`,
    },
    {
      style: 'input-multiple',
      param: 'waybillNos',
      value: '',
      valueType: 'string',
      label: '运单号',
      multiple: true,
      placeholder: '请输入',
      append: '多运单',
      multipleLabel: '运单号',
      multiplePlaceholder:
        '最多可填写50个运单号，需输入完整运单号，运单号中间不能有空格，运单号不换行时请用英文逗号隔开，换行时请每行1个运单号。',
      clearable: true,
    },
    {
      style: 'input-multiple',
      param: 'drivers',
      value: '',
      valueType: 'string',
      label: '司机',
      multiple: true,
      placeholder: '姓名/手机号',
      append: '多司机',
      multipleLabel: '姓名/手机号',
      multiplePlaceholder:
        '最多可填写50个姓名/手机号，需输入完整姓名/手机号，姓名/手机号中间不能有空格，姓名/手机号不换行时请用英文逗号隔开，换行时请每行1个姓名/手机号。',
      clearable: true,
    },
    {
      style: 'input-multiple',
      param: 'vehicles',
      value: '',
      valueType: 'string',
      label: '车牌号',
      multiple: true,
      placeholder: '请输入',
      append: '多车牌号',
      multipleLabel: '车牌号',
      multiplePlaceholder:
        '最多可填写50个车牌号，需输入完整车牌号，车牌号中间不能有空格，车牌号不换行时请用英文逗号隔开，换行时请每行1个车牌号。',
      clearable: true,
    },
    {
      style: 'select',
      param: 'freightStatusList',
      value: [],
      valueType: 'array',
      state: 'pay',
      label: '支付状态',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
      multiple: true,
    },
    {
      style: 'input-multiple',
      param: 'payees',
      value: '',
      valueType: 'string',
      label: '收款人',
      multiple: true,
      placeholder: '姓名',
      append: '多收款人',
      multipleLabel: '姓名',
      multiplePlaceholder:
        '最多可填写50个姓名，需输入完整姓名，姓名中间不能有空格，姓名不换行时请用英文逗号隔开，换行时请每行1个姓名。',
      clearable: true,
    },
    {
      style: 'select',
      param: 'payType',
      value: '',
      valueType: 'string',
      state: 'payType',
      label: '支付方式',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
    },
    {
      style: 'date-picker',
      param: 'insertTime',
      value: [],
      valueType: 'date',
      label: '创建时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      params: ['createStartTime', 'createEndTime'],
    },
    {
      style: 'date-picker',
      param: 'waybillCreateTime',
      value: [],
      valueType: 'date',
      label: '装货时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      params: ['loadingStartTime', 'loadingEndTime'],
    },
    {
      style: 'date-picker',
      param: 'payTime',
      value: [],
      valueType: 'date',
      label: '卸货时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      params: ['unloadingStartTime', 'unloadingEndTime'],
    },
    {
      style: 'select',
      param: 'sourceList',
      value: [],
      valueType: 'array',
      state: 'forms',
      label: '运单来源',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
      multiple: true,
    },

    {
      style: 'select',
      value: '',
      param: 'etc',
      valueType: 'string',
      state: 'etc',
      label: 'ETC',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
    },
    {
      style: 'select',
      param: 'oilSeparation',
      value: '',
      valueType: 'string',
      state: 'oil',
      label: '分油',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
    },
    {
      style: 'select',
      param: 'trajectory',
      value: '',
      valueType: 'string',
      state: 'trajectory',
      label: '轨迹',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
    },
    {
      style: 'select',
      param: 'carryCargoLength',
      value: '',
      valueType: 'string',
      state: 'extent',
      label: '车长',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
    },
    {
      style: 'select',
      param: 'exceptionWaybill',
      value: '',
      valueType: 'string',
      state: 'exception',
      label: '异常运单',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
    },
    {
      style: 'select',
      param: 'channelInfoId',
      value: '',
      valueType: 'string',
      state: 'channelList',
      label: '承运网货',
      placeholder: '请选择',
      noMatchText: '无匹配承运网货',
      clearable: true,
      filterable: false,
      path: `${storeModuleName}/getChannelList`,
    },
    {
      style: 'autocomplete',
      param: 'creatorName',
      value: '',
      valueType: 'string',
      label: '创建人',
      placeholder: '请输入',
      noMatchText: '无匹配请输入',
      clearable: true,
      filterable: false,
      path: `${storeModuleName}/getUserList`,
    },
    {
      style: 'casccader',
      value: [],
      param: 'sendAdministrative',
      label: '装货地',
      placeholder: '请选择',
      clearable: true,
      filterable: true,
      params: ['sendProvince', 'sendCity', 'sendDistrict'],
    },
    {
      style: 'input',
      param: 'sendAddress',
      value: '',
      valueType: 'string',
      label: '详细地址',
      placeholder: '请输入',
      clearable: true,
    },
    {
      style: 'casccader',
      value: [],
      param: 'receiveAdministrative',
      label: '卸货地',
      placeholder: '请选择',
      clearable: true,
      filterable: true,
      params: ['sendProvince', 'sendCity', 'sendDistrict'],
    },
    {
      style: 'input',
      param: 'receiveAddress',
      value: '',
      valueType: 'string',
      label: '详细地址',
      placeholder: '请输入',
      clearable: true,
    },
  ],
  // 特殊筛选项目 带统计信息
  // 按钮筛选项
  isSpecialButton: [
    {
      title: '运单状态',
      name: 'waybillStatus',
      value: '',
      selectList: [
        {
          value: '',
          label: '全部',
          isActive: false,
          countName: '',
          count: 0,
        },
        {
          value: 'WAYBILL_WAIT',
          label: '待接单',
          isActive: false,
          countName: 'WAYBILL_WAIT',
          count: 0,
        },
        {
          value: 'WAYBILL_PUSH',
          label: '待装货',
          isActive: false,
          countName: 'WAYBILL_PUSH',
          count: 0,
        },
        {
          value: 'WAYBILL_START',
          label: '运输中',
          isActive: false,
          countName: 'WAYBILL_START',
          count: 0,
        },
        {
          value: 'WAYBILL_END',
          label: '已卸货',
          isActive: false,
          countName: 'WAYBILL_END',
          count: 0,
        },
      ],
    },
  ],
  // 导出
  isExport: {
    isShow: true,
    method: 'post',
    url: exportExcelTemplate,
  },
  // 页码 + 参数
  postParams: {
    page: 1,
    size: 20,
    routeInfoId: '',
    projectId: '',
    orderByCreateTime: false, // 创建时间排序
    myselfWaybill: 0, // 只看我创建的运单
    freightNotSet: 0, // 未设置运费
    otherException: 0, // 只看异常运单
  },
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '运单',
        prop: 'waybillNo',
        width: 240,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-waybillNo',
      },
      {
        label: '异常提示',
        prop: 'waybillRiskControlDtoList',
        width: 180,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-waybillRiskControlDtoList',
      },
      {
        label: '运单状态',
        prop: 'waybillStatus',
        width: 70,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-waybillStatus',
      },
      {
        label: '装卸货时间',
        prop: 'startTime',
        width: 180,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-startTime',
      },
      {
        label: '司机车辆',
        prop: 'driverName',
        width: 110,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-driverName',
      },
      {
        label: '创建时间',
        prop: 'createTime',
        width: 160,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-createTime',
      },
      {
        label: '运费',
        prop: 'freight',
        width: 720,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-freight',
        slotNameHeader: 'sub-header-freight',
      },
      {
        label: '承运网货',
        prop: 'source',
        width: 200,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-source',
      },
      {
        label: '操作',
        width: 130,
        fixed: 'right',
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-operation',
      },
    ],
  },
  payStatusList: [], // 支付状态统计
  companyList: [], // 企业列表
  channelList: [], // 网络货运平台列表
  companyInfo: '', // 当前选中的企业信息
  projectInfo: '',
  projectList: [], // 项目列表
  routeList: [], // 线路列表
  payPwdExist: '', // 是否设置支付密码
  payPwdStatus: '', // 是否启用支付密码
  forms, // 运单来源
  pay, // 支付状态
  payType, // 运费支付方式
  etc, // ETC
  oil, // 是否分油
  trajectory, // 轨迹
  exception,
  extent, // 载货长度
  filterTestCorp,
};

// getters
const getters = {};

// actions
const actions = {
  // 获取列表数据
  getList: async context => {
    const params = {};
    context.state.parameters.forEach(item => {
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple && item.value === 'string') {
          params[item.param] = item.value.toString();
        } else {
          params[item.param] = item.value;
        }
      }
      if (item.style === 'date-picker' && item.value.length > 0) {
        params[item.params[0]] = `${item.value[0]} 00:00:00`;
        params[item.params[1]] = `${item.value[1]} 23:59:59`;
      }
    });
    context.state.isSpecialButton.forEach(item => {
      if (item.value) params[item.name] = item.value;
    });
    var wdListHabits = {};
    const obj = Object.assign({}, context.state.postParams);
    if (obj.businessId || params.businessId) {
      wdListHabits.businessId = obj.businessId ? obj.businessId : params.businessId;
    }
    if (obj.projectId) {
      wdListHabits.projectId = obj.projectId;
    }
    if (obj.routeInfoId) {
      wdListHabits.routeInfoId = obj.routeInfoId;
    }
    console.log(wdListHabits);
    localStorage.setItem('wdListHabits', JSON.stringify(wdListHabits));
    // 获取统计信息
    if (params.businessId) {
      context.dispatch('getStatistics');
      const { data } = await waybillWdList(Object.assign({}, params, context.state.postParams));
      context.commit('updateState', {
        key: 'listData',
        value: Object.assign({}, context.state.listData, data),
      });
      return data.list;
    }
  },
  // 获取状态统计数据
  getStatistics: async context => {
    const { data } = await countByStatus({
      businessId: context.state.parameters[0].value,
      waybillType: 'ONESTOP_REALTIME',
    });
    context.commit('updateState', {
      key: 'waybillStatus',
      value: data.waybillStatusCountDtoList,
    });
    data &&
      data.waybillStatusCountDtoList.forEach(item => {
        const index = context.state.isSpecialButton[0].selectList.findIndex(selectItem => {
          return selectItem.value === item.waybillStatus;
        });
        context.commit('updateButtonValueFromIndex', {
          index,
          value: item.count,
        });
      });
  },
  // 获取企业列表
  getCompanyList: async (context, payload = 'storage') => {
    let data = JSON.parse(localStorage.getItem('group'));
    if (payload === 'api') {
      const res = await getGroups();
      if (res.code === 200) {
        data = res.data;
        localStorage.setItem('group', JSON.stringify(data));
      }
    }
    if (data && data.id) {
      // 只展示实名认证的企业列表
      context.commit('updateState', {
        key: 'payPwdExist',
        value: data.payPwdExist,
      });
      context.commit('updateState', {
        key: 'payPwdStatus',
        value: data.payPwdStatus,
      });
      const list = data.corporations.filter(item => item.realNameAudit === 1);
      if (list.length) {
        list.forEach(item => {
          item.label = item.principalPartName;
          item.value = item.businessId;
        });
      }
      context.commit('updateState', {
        key: 'companyList',
        value: list,
      });
    }
  },
  // 获取项目列表
  getProjectList: async (context, keyword) => {
    return new Promise(async (resolve, reject) => {
      const { code, data } = await getProjectListByBid({
        businessId: context.state.parameters[0].value,
        keyword,
      });
      if (code === 200) {
        data.list.forEach(item => {
          item.value = item.name;
        });
        context.commit('updateState', {
          key: 'projectList',
          value: data.list,
        });
        resolve(data.list);
      } else {
        reject();
      }
    });
  },
  // 获取线路列表
  getRouteList: async (context, keyword) => {
    return new Promise(async (resolve, reject) => {
      const { code, data } = await getRouteListByBid({
        businessId: context.state.parameters[0].value,
        lineType: 'transfer',
        keyword,
      });
      if (code === 200) {
        data.list.forEach(item => {
          item.value = item.orderName;
        });
        context.commit('updateState', {
          key: 'routeList',
          value: data.list,
        });
        resolve(data.list);
      } else {
        reject();
      }
    });
  },

  // 获取网货列表
  getChannelList: async context => {
    const { code, data } = await findChannelInfoByCorp({
      businessId: context.state.parameters[0].value,
      lineType: 'transfer',
    });
    if (code === 200) {
      const list = data.list.filter(item => {
        return item['supportHistory'] * 1 < 2;
      });
      list.forEach(item => {
        item.value = item.id;
        item.label = item.name;
      });
      context.commit('updateState', {
        key: 'channelList',
        value: list,
      });
    }
  },
  // 获取员工
  getUserList: async (context, keyword) => {
    return new Promise(async (resolve, reject) => {
      const { code, data } = await postGroupUserList({
        page: 1,
        size: 10,
        keyword,
      });
      if (code === 200) {
        data.list.forEach(item => {
          item.value = `${item.name}:${item.mobile}`;
        });
        resolve(data.list);
      } else {
        reject();
      }
    });
  },
};
// mutations
const mutations = {
  // 重置所有状态
  initFilter(state) {
    state.postParams.myselfWaybill = 0;
    state.postParams.freightNotSet = 0;
    state.postParams.otherException = 0;
    state.postParams.orderByCreateTime = false;

    state.postParams.projectId = '';
    state.postParams.routeInfoId = '';
    state.parameters.forEach(item => {
      if (item.isFixed) {
        return;
      }
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple && item.style !== 'input-multiple') {
          item.value = [];
        } else {
          item.value = '';
        }
      }
      if (item.style === 'date-picker') {
        item.value = [];
      }
    });
    state.isSpecialButton.forEach(item => {
      item.value = '';
      item.selectList.forEach(select => {
        select.isActive = item.value.includes(select.value);
      });
    });
  },
  // 更新state数据
  updateState(state, { key, value }) {
    state[key] = value;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
  // 根据index更新value
  updateValueFromIndex(state, payload) {
    state.parameters[payload.index].value = payload.value;
    switch (state.parameters[payload.index].param) {
      case 'businessId':
        if (payload.from !== 1) {
          localStorage.removeItem('wdListHabits');
          localStorage.setItem(
            'wdListHabits',
            JSON.stringify({
              businessId: payload.value,
            }),
          );
        }
        state.companyInfo = state.companyList.find(item => item.businessId === payload.value);
        this.dispatch(`${storeModuleName}/getChannelList`);
        if (state.parameters[1].value) {
          state.parameters[1].value = '';
          state.postParams.projectId = '';
        }
        if (state.parameters[2].value) {
          state.parameters[2].value = '';
          state.postParams.routeInfoId = '';
        }
        break;
      case 'projectName':
        state.postParams.projectId = payload.id;
        state.projectInfo = state.projectList.find(item => item.id === payload.id);
        if (state.parameters[2].value) {
          state.parameters[2].value = '';
          state.postParams.routeInfoId = '';
        }
        break;
      case 'routeInfoName':
        state.postParams.routeInfoId = payload.id;
        break;
      case 'creatorName':
        state.postParams.creatorId = payload.uid;
        break;
      default:
        break;
    }
  },
  // 更新运单号
  updateWaybillNo(state, payload) {
    state.parameters[3].value = payload;
  },
  // 根据index&value更新按钮状态
  updateSpecialStatusFromIndex(state, payload) {
    // 要修改的按钮组
    const specialData = state.isSpecialButton[payload.index];
    specialData.value = payload.value;
    specialData.selectList.forEach(item => {
      item.isActive = item.value === payload.value;
    });
  },
  // 更新按钮统计数据
  updateButtonValueFromIndex(state, payload) {
    state.isSpecialButton[0].selectList[payload.index].count = payload.value;
  },
  upmyselfWaybill(state, payload) {
    state.postParams.myselfWaybill = payload;
  },
  upfreightNotSet(state, payload) {
    state.postParams.freightNotSet = payload;
  },
  upotherException(state, payload) {
    state.postParams.otherException = payload;
  },
  uporderByCreateTime(state, payload) {
    state.postParams.orderByCreateTime = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
